import { TextPill } from 'components/FbUI/TextPill'
import { RebateOfferState } from './tradespend_api'

const OFFER_STATE_LABELS: Record<RebateOfferState, string> = {
  PUBLISHED: 'Published',
  PENDING: 'Pending',
  EXPIRED: 'Expired',
  PAUSED: 'Paused',
  DELETED: 'Deleted',
}

const OFFER_STATE_COLORS: Record<RebateOfferState, [string, string]> = {
  // [bg, text] — light tint + 700 text, matching the DS2026 50/700 badge palette
  PUBLISHED: ['#dcfce7', '#15803d'], // green
  PENDING: ['#fef3c7', '#b45309'], // amber
  EXPIRED: ['#e0f2fe', '#0369a1'], // sky
  PAUSED: ['#f3f4f6', '#374151'], // gray
  DELETED: ['#fee2e2', '#b91c1c'], // red
}

interface RebateOfferStatePillProps {
  state: RebateOfferState
}

export function RebateOfferStatePill({ state }: RebateOfferStatePillProps) {
  const label = OFFER_STATE_LABELS[state]
  const [bg, text] = OFFER_STATE_COLORS[state]

  return (
    <TextPill backgroundColor={bg} textColor={text}>
      {label}
    </TextPill>
  )
}
